import {
  Button,
  Col,
  Form,
  Input,
  Layout,
  Row,
  Typography,
  Upload,
  message,
} from "antd";

import JoditEditor from "jodit-react";
import { CiImageOn } from "react-icons/ci";
import { LuSend } from "react-icons/lu";
import { useEffect, useState } from "react";
import {
  BASE_URL,
  COACH,
  COMMUNITY,
  UPLOAD_URL2,
} from "../../config/constants/api";
import { CONTENT_TYPE } from "../../config/constants/index";
import { Post } from "../../config/api/post";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import { useSelector } from "react-redux";
import { Get } from "../../config/api/get";
import { useLocation } from "react-router";
import axios from "axios";
import { ImageUrl } from "../../helpers/Functions";
import "./create-form.css";

export default function CreateForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const post = location?.state?.post;
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.user.userToken);

  const config = {
    readonly: false,
    placeholder: "Enter Post Description",
  };

  const [students, setStudents] = useState([]);
  const [communityMembers, setCommunityMembers] = useState([]);
  const [, setLoading3] = useState(false);

  const getMyStudents = async (pageNumber) => {
    setLoading3(true);
    try {
      const response = await Get(COACH.getMyStudents, token, {
        page: "1",
        limit: "10",
      });
      setLoading3(false);
      if (response?.status) {
        setStudents(response?.data?.students);
      } else {
        // message.error(response.message);
        console.log("error====>", response);
      }
    } catch (error) {
      console.log(error.message);
      setLoading3(false);
    }
  };
  useEffect(() => {
    getMyStudents();
    if (post?.members?.length > 0) {
      post.members.forEach((member) => {
        setCommunityMembers((prev) => [...prev, member._id]);
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [fileListImage, setFileListImage] = useState([]);
  const handleImageChange = ({ fileList }) => setFileListImage(fileList);

  const onFinish = (values) => {
    setLoading(true);
    const formObject = new FormData();

    const data = {
      title: values.title,
      description: values.description,
    };

    for (const key in data) {
      if (key !== "image") {
        formObject.append(
          key,
          Array.isArray(data[key]) ? JSON.stringify(data[key]) : data[key]
        );
      }
    }

    // Append image files individually
    if (fileListImage.length > 0) {
      fileListImage.forEach((file) => {
        formObject.append("image", file.originFileObj); // Append each image file
      });
    }

    let members = JSON.stringify([]);

    if (communityMembers.length > 0) {
      members = JSON.stringify(communityMembers);
    }

    formObject.append("members", members);

    Post(COMMUNITY.addPost, formObject, token, null, CONTENT_TYPE.FORM_DATA)
      .then((response) => {
        setLoading(false);
        console.log(response);
        if (response?.data?.status) {
          swal("Success", "Post added successfully", "success");
          navigate(-1);
        } else {
          swal(
            "Oops!",
            response?.data?.message || response?.response?.data?.message,
            "error"
          );
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
        message.error("An error occurred while adding the post.");
      });
  };

  async function updatePost(values) {
    setLoading(true);
    let data = new FormData();
    data.append("title", values.title);
    data.append("description", values.description);
    data.append("members", JSON.stringify(communityMembers));
    data.append("image", fileListImage[0]?.originFileObj || post?.thumbnail);

    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${BASE_URL}/community/${post._id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data,
    };

    axios
      .request(config)
      .then((response) => {
        setLoading(false);
        console.log("responst", response);
        if (response.status === 200) {
          swal("Success", "Post Updated successfully", "success");
          navigate(-1);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        swal(
          "Oops!",
          error || error?.response?.data?.message || "Something went wrong",
          "error"
        );
      });
  }

  function addCommunityMember(id) {
    let temp = [...communityMembers];
    if (temp.includes(id)) {
      temp = temp.filter((item) => item !== id);
    } else {
      temp.push(id);
    }
    setCommunityMembers(temp);
  }

  return (
    <Layout className="create-form-page" style={{ minHeight: "100vh" }}>
      <Row
        className="blueBackground create-form-bnr create-form-banner"
        justify="center"
        align="middle"
      >
        <div className="create-form-banner-overlay" aria-hidden />
        <div className="create-form-banner-orb" aria-hidden />
        <div className="create-form-banner-content-wrap">
          <div className="create-form-banner-content">
            <Typography.Title
              level={1}
              className="fontFamily1 create-form-banner-title"
            >
              Community
            </Typography.Title>
            <Typography.Text className="fontFamily1 create-form-banner-subtitle">
              {post
                ? "Update your post and choose which students can take part."
                : "Share with your community—pick a title, story, image, and members."}
            </Typography.Text>
          </div>
        </div>
      </Row>

      <Row gutter={[24, 24]} className="create-form-layout">
        <Col xs={24} lg={8}>
          <div className="create-form-members-panel">
            <div className="create-form-members-header">
              <Typography.Title level={5} className="create-form-members-title">
                Add students to community
              </Typography.Title>
              <Typography.Text type="secondary" className="text-sm block mt-1">
                Choose who should see this post in the community feed.
              </Typography.Text>
              {students.length > 0 && (
                <span className="create-form-selected-badge">
                  {communityMembers.length} selected
                </span>
              )}
            </div>
            <div className="create-form-members-scroll">
              {students.length > 0 ? (
                students.map((user, index) => (
                  <div key={index} className="create-form-member-row">
                    <div className="flex min-w-0 flex-1 items-center gap-3">
                      <img
                        src={
                          user?.image
                            ? UPLOAD_URL2 + user.image
                            : ImageUrl("avatar.png")
                        }
                        alt=""
                      />
                      <p className="create-form-member-name">
                        {user.firstName + " " + user.lastName}
                      </p>
                    </div>
                    <input
                      onChange={() => addCommunityMember(user._id)}
                      type="checkbox"
                      checked={communityMembers.includes(user._id)}
                      className="create-form-member-check"
                      aria-label={`Include ${user.firstName} ${user.lastName}`}
                    />
                  </div>
                ))
              ) : (
                <div className="create-form-empty">No User Found</div>
              )}
            </div>
          </div>
        </Col>

        <Col xs={24} lg={16}>
          <div className="create-form-editor-panel">
            <div className="create-form-editor-head">
              <Typography.Title level={3} className="create-form-editor-title">
                {post ? "Edit post" : "Create post"}
              </Typography.Title>
              <Typography.Paragraph className="create-form-editor-desc">
                {post
                  ? "Change the details below. Your existing cover image stays unless you upload a new one."
                  : "Fill in each section. You can invite students from the list on the left."}
              </Typography.Paragraph>
            </div>

            <Form
              layout="vertical"
              initialValues={{
                title: post?.title || "",
                description: post?.description || "",
              }}
              name="post-add"
              onFinish={post ? updatePost : onFinish}
              onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
              className="w-full"
            >
              <Form.Item
                label="Post Title"
                name="title"
                rules={[
                  { required: true, message: "Please input Post Title!" },
                ]}
                className="w-full mb-6"
              >
                <Input
                  value={post?.title}
                  size="large"
                  placeholder="Enter Post Title"
                  className="create-form-title-input h-12"
                />
              </Form.Item>

              <Form.Item
                label="Post Description"
                name="description"
                className="w-full mb-6"
                rules={[
                  { required: true, message: "Please enter Post Description!" },
                ]}
              >
                <div className="create-form-jodit-wrap">
                  <JoditEditor
                    value={post?.description || ""}
                    className="min-h-[200px] border-0 focus:outline-none"
                    config={config}
                  />
                </div>
              </Form.Item>

              {post?.thumbnail && (
                <Form.Item className="w-full mb-6">
                  <div className="create-form-thumb-wrap">
                    <img
                      src={UPLOAD_URL2 + post.thumbnail}
                      alt="Current post thumbnail"
                    />
                  </div>
                </Form.Item>
              )}

              <div className="create-form-actions">
                <Form.Item
                  label="Post Image"
                  name="image"
                  className="mb-0 flex-1 min-w-[200px]"
                  rules={[
                    {
                      required: post?.thumbnail ? false : true,
                      message: "Please upload an image!",
                    },
                  ]}
                >
                  <Upload
                    listType="picture"
                    fileList={fileListImage}
                    onChange={handleImageChange}
                    accept="image/*"
                    maxCount={1}
                  >
                    <Button
                      type="primary"
                      size="large"
                      icon={<CiImageOn size={20} />}
                      className="create-form-btn-primary flex items-center justify-center gap-2"
                    >
                      {post?.thumbnail ? "update Image" : "Add Image"}
                    </Button>
                  </Upload>
                </Form.Item>
                <Form.Item className="mb-0">
                  <Button
                    htmlType="submit"
                    size="large"
                    icon={!loading && <LuSend size={20} />}
                    className="create-form-btn-primary flex w-full items-center justify-center gap-2 sm:w-auto"
                  >
                    {loading ? (
                      <span
                        className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-dashed border-white border-t-transparent"
                        aria-hidden
                      />
                    ) : post ? (
                      "Update"
                    ) : (
                      "Publish"
                    )}
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </div>
        </Col>
      </Row>
    </Layout>
  );
}
